export default "__VITE_ASSET__CGvN6fVK__"